import { AlertCircleIcon, ArrowLeftIcon, HomeIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-linear-to-br from-background via-background to-muted/20 p-4">
      <div className="max-w-2xl w-full space-y-6">
        <Card className="border-2 shadow-lg">
          <CardHeader className="text-center space-y-4 pb-6">
            <div className="mx-auto w-24 h-24 rounded-full bg-destructive/10 flex items-center justify-center">
              <HugeiconsIcon icon={AlertCircleIcon} className="h-12 w-12 text-destructive" />
            </div>
            <div className="space-y-2">
              <CardTitle className="text-4xl font-bold">404</CardTitle>
              <CardDescription className="text-lg">Page Not Found</CardDescription>
            </div>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="text-center space-y-2">
              <p className="text-muted-foreground">
                Oops! The page you're looking for doesn't exist or has been moved.
              </p>
              <p className="text-sm text-muted-foreground">
                The URL might be incorrect, or the page may have been removed.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button asChild size="lg" className="gap-2">
                <Link to="/home">
                  <HugeiconsIcon icon={HomeIcon} className="h-4 w-4" />
                  Go to Homepage
                </Link>
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="gap-2"
                onClick={() => window.history.back()}
              >
                <HugeiconsIcon icon={ArrowLeftIcon} className="h-4 w-4" />
                Go Back
              </Button>
            </div>

            <div className="pt-6 border-t">
              <p className="text-sm text-center text-muted-foreground mb-3">Quick Links</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                <Button asChild variant="ghost" size="sm" className="justify-start">
                  <Link to="/home">Dashboard</Link>
                </Button>
                <Button asChild variant="ghost" size="sm" className="justify-start">
                  <Link to="/tickets" search={{ ticketId: undefined }}>
                    Tickets
                  </Link>
                </Button>
                <Button asChild variant="ghost" size="sm" className="justify-start">
                  <Link to="/assets" search={{ tab: 'overview', assetId: undefined }}>
                    Assets
                  </Link>
                </Button>
                <Button asChild variant="ghost" size="sm" className="justify-start">
                  <Link to="/preventive-maintenance">PM</Link>
                </Button>
                <Button asChild variant="ghost" size="sm" className="justify-start">
                  <Link to="/checklist-management">Checklists</Link>
                </Button>
                <Button asChild variant="ghost" size="sm" className="justify-start">
                  <Link to="/settings">Settings</Link>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
